// frontend/src/constants/adminOrderConstants.js

export const ADMIN_ORDER_LIST_REQUEST = "ADMIN_ORDER_LIST_REQUEST";
export const ADMIN_ORDER_LIST_SUCCESS = "ADMIN_ORDER_LIST_SUCCESS";
export const ADMIN_ORDER_LIST_FAIL = "ADMIN_ORDER_LIST_FAIL";
export const ADMIN_ORDER_LIST_RESET = "ADMIN_ORDER_LIST_RESET";

export const ADMIN_ORDER_DETAILS_REQUEST = "ADMIN_ORDER_DETAILS_REQUEST";
export const ADMIN_ORDER_DETAILS_SUCCESS = "ADMIN_ORDER_DETAILS_SUCCESS";
export const ADMIN_ORDER_DETAILS_FAIL = "ADMIN_ORDER_DETAILS_FAIL";
export const ADMIN_ORDER_DETAILS_RESET = "ADMIN_ORDER_DETAILS_RESET";

export const ADMIN_ORDER_ANALYTICS_REQUEST = "ADMIN_ORDER_ANALYTICS_REQUEST";
export const ADMIN_ORDER_ANALYTICS_SUCCESS = "ADMIN_ORDER_ANALYTICS_SUCCESS";
export const ADMIN_ORDER_ANALYTICS_FAIL = "ADMIN_ORDER_ANALYTICS_FAIL";
export const ADMIN_ORDER_ANALYTICS_RESET = "ADMIN_ORDER_ANALYTICS_RESET";

export const ADMIN_ORDER_STATUS_UPDATE_REQUEST =
  "ADMIN_ORDER_STATUS_UPDATE_REQUEST";
export const ADMIN_ORDER_STATUS_UPDATE_SUCCESS =
  "ADMIN_ORDER_STATUS_UPDATE_SUCCESS";
export const ADMIN_ORDER_STATUS_UPDATE_FAIL = "ADMIN_ORDER_STATUS_UPDATE_FAIL";
export const ADMIN_ORDER_STATUS_UPDATE_RESET =
  "ADMIN_ORDER_STATUS_UPDATE_RESET";

export const ADMIN_ORDER_FULFILLMENT_UPDATE_REQUEST =
  "ADMIN_ORDER_FULFILLMENT_UPDATE_REQUEST";
export const ADMIN_ORDER_FULFILLMENT_UPDATE_SUCCESS =
  "ADMIN_ORDER_FULFILLMENT_UPDATE_SUCCESS";
export const ADMIN_ORDER_FULFILLMENT_UPDATE_FAIL =
  "ADMIN_ORDER_FULFILLMENT_UPDATE_FAIL";
export const ADMIN_ORDER_FULFILLMENT_UPDATE_RESET =
  "ADMIN_ORDER_FULFILLMENT_UPDATE_RESET";

export const ADMIN_ORDER_CUT_STATUS_UPDATE_REQUEST =
  "ADMIN_ORDER_CUT_STATUS_UPDATE_REQUEST";
export const ADMIN_ORDER_CUT_STATUS_UPDATE_SUCCESS =
  "ADMIN_ORDER_CUT_STATUS_UPDATE_SUCCESS";
export const ADMIN_ORDER_CUT_STATUS_UPDATE_FAIL =
  "ADMIN_ORDER_CUT_STATUS_UPDATE_FAIL";
export const ADMIN_ORDER_CUT_STATUS_UPDATE_RESET =
  "ADMIN_ORDER_CUT_STATUS_UPDATE_RESET";

export const ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_REQUEST =
  "ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_REQUEST";
export const ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_SUCCESS =
  "ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_SUCCESS";
export const ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_FAIL =
  "ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_FAIL";
export const ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_RESET =
  "ADMIN_ORDER_MANUAL_PAYMENT_UPDATE_RESET";

export const ADMIN_ORDER_REFUND_REQUEST = "ADMIN_ORDER_REFUND_REQUEST";
export const ADMIN_ORDER_REFUND_SUCCESS = "ADMIN_ORDER_REFUND_SUCCESS";
export const ADMIN_ORDER_REFUND_FAIL = "ADMIN_ORDER_REFUND_FAIL";
export const ADMIN_ORDER_REFUND_RESET = "ADMIN_ORDER_REFUND_RESET";

export const ADMIN_RETURN_LIST_REQUEST = "ADMIN_RETURN_LIST_REQUEST";
export const ADMIN_RETURN_LIST_SUCCESS = "ADMIN_RETURN_LIST_SUCCESS";
export const ADMIN_RETURN_LIST_FAIL = "ADMIN_RETURN_LIST_FAIL";
export const ADMIN_RETURN_LIST_RESET = "ADMIN_RETURN_LIST_RESET";

export const ADMIN_RETURN_DETAILS_REQUEST = "ADMIN_RETURN_DETAILS_REQUEST";
export const ADMIN_RETURN_DETAILS_SUCCESS = "ADMIN_RETURN_DETAILS_SUCCESS";
export const ADMIN_RETURN_DETAILS_FAIL = "ADMIN_RETURN_DETAILS_FAIL";
export const ADMIN_RETURN_DETAILS_RESET = "ADMIN_RETURN_DETAILS_RESET";

export const ADMIN_RETURN_APPROVE_REQUEST = "ADMIN_RETURN_APPROVE_REQUEST";
export const ADMIN_RETURN_APPROVE_SUCCESS = "ADMIN_RETURN_APPROVE_SUCCESS";
export const ADMIN_RETURN_APPROVE_FAIL = "ADMIN_RETURN_APPROVE_FAIL";
export const ADMIN_RETURN_APPROVE_RESET = "ADMIN_RETURN_APPROVE_RESET";

export const ADMIN_RETURN_REJECT_REQUEST = "ADMIN_RETURN_REJECT_REQUEST";
export const ADMIN_RETURN_REJECT_SUCCESS = "ADMIN_RETURN_REJECT_SUCCESS";
export const ADMIN_RETURN_REJECT_FAIL = "ADMIN_RETURN_REJECT_FAIL";
export const ADMIN_RETURN_REJECT_RESET = "ADMIN_RETURN_REJECT_RESET";

export const ADMIN_RETURN_RECEIVED_REQUEST = "ADMIN_RETURN_RECEIVED_REQUEST";
export const ADMIN_RETURN_RECEIVED_SUCCESS = "ADMIN_RETURN_RECEIVED_SUCCESS";
export const ADMIN_RETURN_RECEIVED_FAIL = "ADMIN_RETURN_RECEIVED_FAIL";
export const ADMIN_RETURN_RECEIVED_RESET = "ADMIN_RETURN_RECEIVED_RESET";

export const ADMIN_RETURN_REFUND_REQUEST = "ADMIN_RETURN_REFUND_REQUEST";
export const ADMIN_RETURN_REFUND_SUCCESS = "ADMIN_RETURN_REFUND_SUCCESS";
export const ADMIN_RETURN_REFUND_FAIL = "ADMIN_RETURN_REFUND_FAIL";
export const ADMIN_RETURN_REFUND_RESET = "ADMIN_RETURN_REFUND_RESET";

export const ADMIN_ORDER_RESET_ERROR = "ADMIN_ORDER_RESET_ERROR";
export const ADMIN_ORDER_RESET_META = "ADMIN_ORDER_RESET_META";
export const ADMIN_ORDER_RESET_STATE = "ADMIN_ORDER_RESET_STATE";